import { Text } from '@linktr.ee/arbor/components/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';
interface UsernameSuggestionProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
}

const UsernameSuggestion: React.FC<UsernameSuggestionProps> = ({
  suggestions,
  onSuggestionClick,
}) => {
  const { t } = useTranslation();

  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div className="pt-md pb-lg flex flex-col lg:!flex-row items-start lg:!items-center space-y-xs lg:!space-y-0 flex-wrap">
      <Text as="span" variant="body-small-medium" className="pr-xs text-black">
        {t('Available:')}
      </Text>
      {suggestions.map((suggestion, index) => (
        <Button
          key={index}
          variant="link"
          fullWidth={false}
          className="mr-md last:mr-0"
          onClick={() => onSuggestionClick(suggestion)}
        >
          {suggestion}
        </Button>
      ))}
    </div>
  );
};

export default UsernameSuggestion;
